import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

interface LocationState {
    email?: string;
    message?: string;
}

const VerificationPending: React.FC = () => {
    const location = useLocation();
    const state = location.state as LocationState;
    const email = state?.email || '';
    const message = state?.message || 'Please check your email to verify your account.';

    return (
        <Container maxWidth="sm">
            <Box sx={{ mt: 8, mb: 4 }}>
                <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
                    <EmailIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2 }} />
                    
                    <Typography variant="h5" component="h1" gutterBottom>
                        Verify Your Email
                    </Typography>
                    
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        {message}
                    </Typography>
                    
                    {email && (
    <>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            We've sent a verification link to:
        </Typography>
        <Box sx={{ fontWeight: 'bold', mb: 3 }}>
            {email}
        </Box>
    </>
)}
                    
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                        Please click the verification link in the email to activate your account.
                        The link will expire in 24 hours.
                    </Typography>
                    
                    <Button
                        component={RouterLink}
                        to="/login"
                        variant="contained"
                        color="primary"
                        fullWidth
                    >
                        Go to Login
                    </Button>
                </Paper>
            </Box>
        </Container>
    );
};

export default VerificationPending;
